var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3477_32737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7791 19.7819L15.4769 22.6417C14.4697 22.8184 13.5093 22.1493 13.3317 21.1473L11.5372 11.0225C11.3596 10.0204 12.0322 9.06485 13.0394 8.88816L29.3415 6.0283C30.3487 5.85161 31.3092 6.52072 31.4868 7.52276L33.2812 17.6475C33.4589 18.6496 32.7863 19.6052 31.7791 19.7819Z",
    fill: "#CCCED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3405 6.0283L21.1895 7.45823L23.627 21.2119L31.7781 19.7819C32.7853 19.6052 33.4578 18.6497 33.2802 17.6476L31.4858 7.52281C31.3082 6.52072 30.3477 5.85161 29.3405 6.0283Z",
    fill: "#96969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6609 26.0001H11.4573C10.4346 26.0001 9.60547 25.1752 9.60547 24.1577V14.1296C9.60547 13.1121 10.4346 12.2872 11.4573 12.2872H27.6609C28.6837 12.2872 29.5128 13.1121 29.5128 14.1296V24.1577C29.5128 25.1752 28.6837 26.0001 27.6609 26.0001Z",
    fill: "#96969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6614 12.2872H19.5596V26.0001H27.6614C28.6841 26.0001 29.5132 25.1752 29.5132 24.1577V14.1296C29.5132 13.1121 28.6841 12.2872 27.6614 12.2872Z",
    fill: "#CCCED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60547 15.4216H29.5128V18.556H9.60547V15.4216Z",
    fill: "#CCCED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1183 22.9578H11.9679C11.5844 22.9578 11.2734 23.2671 11.2734 23.6487C11.2734 24.0302 11.5844 24.3396 11.9679 24.3396H15.1183C15.5018 24.3396 15.8128 24.0302 15.8128 23.6487C15.8128 23.2671 15.5018 22.9578 15.1183 22.9578Z",
    fill: "#CCCED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5596 15.4216H29.5132V18.556H19.5596V15.4216Z",
    fill: "#96969A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3477_32737",
    x: 0.605469,
    y: 0,
    width: 43.7041,
    height: 40.0001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3477_32737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3477_32737",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardsLight);
export default __webpack_public_path__ + "static/media/credit-cards-light.3e2e592e3a57b58977a8c66da8e82b4a.svg";
export { ForwardRef as ReactComponent };